import { IPhongBan } from "../../model/respone/category/IPhongBan";
import { apiClient } from "../apiClient";

export const PHONG_BAN_API = "phong-ban";
export const phongBanApi = {
  SelectAll: () => apiClient.get(`${PHONG_BAN_API}`),
  Insert: (payload: IPhongBan) => apiClient.post(`${PHONG_BAN_API}`, payload),
  Update: (payload: IPhongBan) => apiClient.put(`${PHONG_BAN_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${PHONG_BAN_API}/${id}`),
};
